export class ClientRequest {
  constructor(
    token = "",
    connectToSystem = "SYCA",
    connectTo = "SRVSQL",
    connectToLogin = "S",
    nombre = "",
    titulo = "",
    fuente = "",
    sessions = [],
    browser = [],
    petitions = []
  ) {
    this.token = token;
    this.connectTo = connectTo;
    this.connectToLogin = connectToLogin;
    this.connectToSystem = connectToSystem;
    this.sessions = sessions;
    this.browser = browser;
    this.petitions = petitions;
    this.nombre = nombre;
    this.titulo = titulo;
    this.fuente = fuente;
  }

  //   add_session(_item) {
  //     this.session.push(_item);
  //   }

  add_session(_name = "", _value = null) {
    if (_name.length != 0) {
      this.add_session({ name: _name, value: _value, type: "value" });
    }
  }
}
